import React, { useState } from 'react';
import { FaUser, FaGoogle, FaEnvelope, FaLock } from 'react-icons/fa'; // Import icons
import Header from '../components/headerfooter/Header';
import Footer from '../components/headerfooter/Footer';
import CallToAction from '../components/home/CallToAction';
import PageBanner from '../components/PageBanner';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import { NavLink, useNavigate } from 'react-router';
import axios from 'axios';
import { REACT_APP_API_PORT } from '../Api';
import Loader from '../components/Loader';
import { auth, provider } from '../firebase/firebase';
import {  signInWithPopup } from 'firebase/auth';
import { storeEncryptedData } from '../config/crypto';
const SignupPage = (props) => {
  const navigate = useNavigate()
  const [apiIsLoading, setapiIsLoading] = useState(false)

  const urlToFile = async (photoURL, fileName) => {
    try {
      const response = await fetch(photoURL);
      const blob = await response.blob();
      const file = new File([blob], fileName, { type: blob.type });
      return file;
    } catch (error) {
      console.error("Error converting photoURL to file:", error);
    }
  };

  const handleGoogleSignup = async () => {
    const data = await signInWithPopup(auth, provider);

    if (!data) {
      props.setAlertBox(true)
      props.showAlert("Something went wrong!", "error")
      return;
    }



    let updateData = {
      name: data?.user?.displayName,
      email: data?.user?.email,
      phone: data?.user?.phoneNumber
    }

    if (data?.user?.photoURL) {
      const profileImage = await urlToFile(data?.user?.photoURL, `image-${Date.now()}-${data?.user?.displayName}.jpg`);
      if (profileImage) {
        updateData.image = profileImage
      }
    }

    try {
      setapiIsLoading(true)
      const res = await axios.post(`${REACT_APP_API_PORT}user/auth/social-login`, updateData)
      setapiIsLoading(false)
      if (res.data.status) {
        storeEncryptedData("user", res.data.data);
        storeEncryptedData("token", res.data.jwtoken);

        
        props.setAlertBox(true)
        props.showAlert(res.data.message, "success")
        navigate('/')
      }
    }
    catch (err) {
      console.log(err)
      setapiIsLoading(false)
      if (err.response.data.status === false) {
        props.setAlertBox(true)
        props.showAlert(err.response.data.message, "error")
      }
    }

    console.log('Google Signup Clicked');
  };

  

  const validate = yup.object({
    name: yup.string().min(2).max(50).required("Name is required"),
    email: yup.string().email().max(150).required("Email is required"),
    password: yup.string().min(6).max(30).required("Password is required"),
    confirm_password: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const renderError = (message) => (
    <p className="italic text-[#dd1212]">{message}</p>
  );

  const handleSubmit = async (values) => {
    try {
      setapiIsLoading(true)
      const res = await axios.post(`${REACT_APP_API_PORT}user/auth/signup`, {
        name: values.name,
        email: values.email,
        password: values.password
      })
      setapiIsLoading(false)
      if (res.data.status) {
        props.setAlertBox(true)
        props.showAlert(res.data.message, "success")
        navigate('/login')
      }
    }
    catch (err) {
      console.log(err)
      setapiIsLoading(false)
      if (err.response.data.status === false) {
        props.setAlertBox(true)
        props.showAlert(err.response.data.message, "error")
      }
    }
  }

  return (
    <>
      <Loader isLoading={apiIsLoading} />
      {/* <TopBar /> */}
      <Header />
      <PageBanner title="Sign Up" para="Create your account and join us today." />

      <Formik
        initialValues={{
          name: "",
          email: "",
          password: "",
          confirm_password: "",
        }}
        validationSchema={validate}
        onSubmit={(values, actions) => {
          console.log(values)
          handleSubmit(values)
        }}
      >

        {({ values, setFieldValue }) => (
          <Form>
            <div className="flex items-center justify-center bg-background-back1 py-6 px-6 ">
              <div className="max-w-lg w-full  text-gray-100 rounded-2xl shadow-lg overflow-hidden border-white/10 border">
                <div className="bg-background-back2 p-6 text-center rounded-t-2xl">
                  <h2 className="text-[30px] md:text-[36px] font-bold">Join Us</h2>
                  <p className="mt-2 text-gray-400">Sign up to get started</p>
                </div>
                <div className="p-3 md:p-8">


                  <div className="relative mb-3">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-300">
                      Full Name
                    </label>
                    <div className="flex items-center mt-2 rounded-lg bg-background-back1 border border-gray-600 focus-within:ring-2 focus-within:ring-blue-500">
                      <span className="flex items-center px-3 text-gray-400">
                        <FaUser />
                      </span>
                      <Field
                        type="text"
                        id="name"
                        name="name"
                        className="w-full px-4 py-3 bg-transparent focus:outline-none focus:ring-0 text-gray-200"
                        placeholder="Your Name"

                      />

                    </div>
                    <ErrorMessage name="name" render={renderError} />
                  </div>


                  <div className="relative  mb-3">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-300">
                      Email Address
                    </label>
                    <div className="flex items-center mt-2 rounded-lg bg-background-back1 border border-gray-600 focus-within:ring-2 focus-within:ring-blue-500">
                      <span className="flex items-center px-3 text-gray-400">
                        <FaEnvelope />
                      </span>
                      <Field
                        type="email"
                        id="email"
                        name="email"
                        className="w-full px-4 py-3 bg-transparent focus:outline-none focus:ring-0 text-gray-200"
                        placeholder="you@example.com"

                      />

                    </div>
                    <ErrorMessage name="email" render={renderError} />

                  </div>


                  <div className="relative  mb-3">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-300">
                      Password
                    </label>
                    <div className="flex items-center mt-2 rounded-lg bg-background-back1 border border-gray-600 focus-within:ring-2 focus-within:ring-blue-500">
                      <span className="flex items-center px-3 text-gray-400">
                        <FaLock />
                      </span>
                      <Field
                        type="password"
                        id="password"
                        name="password"
                        className="w-full px-4 py-3 bg-transparent focus:outline-none focus:ring-0 text-gray-200"
                        placeholder="********"

                      />
                    </div>
                    <ErrorMessage name="password" render={renderError} />

                  </div>


                  <div className="relative  mb-3">
                    <label htmlFor="confirm_password" className="block text-sm font-medium text-gray-300">
                      Confirm Password
                    </label>
                    <div className="flex items-center mt-2 rounded-lg bg-background-back1 border border-gray-600 focus-within:ring-2 focus-within:ring-blue-500">
                      <span className="flex items-center px-3 text-gray-400">
                        <FaLock />
                      </span>
                      <Field
                        type="password"
                        id="confirm_password"
                        name="confirm_password"
                        className="w-full px-4 py-3 bg-transparent focus:outline-none focus:ring-0 text-gray-200"
                        placeholder="********"

                      />

                    </div>
                    <ErrorMessage name="confirm_password" render={renderError} />

                  </div>


                  <button
                    type="submit"
                    className="mt-2 border-2 border-customBlue px-4 py-3 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase w-full"
                  >
                    Sign Up
                  </button>

                </div>

                <div className="p-6 bg-background-back2">
                  <div className="text-center text-gray-300 font-medium mb-4">Or continue with</div>
                  <div className="flex space-x-4 justify-center">
                    {/* Google Signup */}
                    <button
                    type='button'
                      onClick={handleGoogleSignup}
                      className="flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg shadow-md space-x-2 transition-all"
                    >
                      <FaGoogle size={18} />
                      <span>Google</span>
                    </button>

               
                  </div>
                  <p className="text-center text-sm text-gray-300 mt-6">
                    Already have an account?{' '}
                    <NavLink to='/login' className="text-blue-400 hover:underline">
                      Sign in
                    </NavLink>
                  </p>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <CallToAction />
      <Footer />
    </>
  );
};

export default SignupPage;
